import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import iView from 'iview';
import locale from 'iview/dist/locale/en-US';
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'iview/dist/styles/iview.css';
import contentmenu from 'v-contextmenu';
import gridLayout from 'vue-grid-layout';
import VueDraggableResizable from 'vue-draggable-resizable';
import VueChatScroll from 'vue-chat-scroll';
import 'v-contextmenu/dist/index.css';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import echarts from 'echarts';
import 'echarts/theme/macarons.js';
import 'echarts/theme/vintage.js';
import 'echarts/theme/dark.js';
import 'echarts/theme/shine.js';
import 'echarts/theme/roma.js';
import App from './App';
import utils from './utils';
import store from './store';
import router from './router';
import Request from './utils/request';


// let a = process.env.Ap
/* eslint-disable no-new */

// 自定义假数据，如果不用或者打包，注释掉mock
// import './mock';

Vue.use(utils);
Vue.use(ElementUI);
Vue.use(iView, { locale });
Vue.use(contentmenu);
Vue.use(gridLayout);
Vue.use(VueChatScroll);
Vue.use(VueVideoPlayer);
Vue.config.productionTip = false;
Vue.prototype.$get = Request.get;
Vue.prototype.$post = Request.post;
Vue.prototype.$echarts = echarts;
Vue.component('vue-draggable-resizable', VueDraggableResizable);

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js